import { render, staticRenderFns } from "./StockTrfNew_Items_List.vue?vue&type=template&id=bd55594a&"
import script from "./StockTrfNew_Items_List.vue?vue&type=script&lang=js&"
export * from "./StockTrfNew_Items_List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports